import React from "react";

interface EyebrowProps {
  children: React.ReactNode;
  color?: string;
}

const Eyebrow: React.FC<EyebrowProps> = ({ children, color = "#0076e9" }) => {
  const bgColorMap: Record<string, string> = {
    "#a881db": "bg-purple-a8/10",
    "#0076e9": "bg-blue-00/10",
    "#00c1a3": "bg-teal-00/10",
  };

  const textColorMap: Record<string, string> = {
    "#a881db": "text-purple-a8",
    "#0076e9": "text-blue-00",
    "#00c1a3": "text-teal-00",
  };

  const bgClass = bgColorMap[color] || "bg-blue-00/10";
  const textClass = textColorMap[color] || "text-blue-00";

  return (
    <span
      className={`inline-flex items-center gap-1.5 ${bgClass} ${textClass} rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-widest mb-4`}
    >
      {children}
    </span>
  );
};

export default Eyebrow;
